<div [class]="'c-eventProgress-bar'">
  <span class="c-eventProgressBar__left-icon">
    <ng-content select="[eventProgressBarIcon] [eventProgressBarIconPos=left]"></ng-content>
  </span>

  <div class="c-progress">
    <div class="c-progress__track">
      <div class="c-progress__fill"></div>
    </div>
  </div>

  <div class="position-absolute t-0">
    <ng-content></ng-content>
  </div>

  <div class="c-eventProgress__container">
    <div class="c-eventProgress__items">
      @for (item of pointsPerBagMultiplier; track item; let i = $index) {
        <div class="square">
          <slotcom-tooltip-bubble
            [id]="'tooltip-bubble-' + i"
            [ngClass]="i === pointsPerBagMultiplier.length - 1 ? 'move-tooltip' : ''"
            [classes]="[
              'c-tooltipBubble--eventProgress',
              i === pointsPerBagMultiplier.length - 1 ? 'last-tooltip' : '',
              iconStates()[i] ? 'c-tooltipBubble--eventProgress--activated' : ''
            ]"
            arrowPosition="bottom"
            arrowPercentPosition()="40"
            borderRadius()="10">
            <div
              tooltipBubbleIcon
              tooltipBubbleIconPos="left"
              class="c-tooltipIcon--coin"></div>
            <span class="item-price">{{
              item.bagMultiplier * event.properties.recurring | beautifyNumber: ('common.culture' | translate)
            }}</span>
          </slotcom-tooltip-bubble>
          @if (i < pointsPerBagMultiplier.length - 1) {
            <span
              class="item-icon"
              [ngStyle]="{ 'background-image': 'url(' + iconStateAssets()[i] + ')' }"></span>
          } @else {
            <span
              class="item-icon"
              [ngClass]="'last-icon'"
              [ngStyle]="{ 'background-image': 'url(' + iconStateAssets()[i] + ')' }"></span>
          }
          <span class="item-points">{{ item.points | number: '1.0-0' : ('common.culture' | translate) }}</span>
        </div>
      }
    </div>

    <div class="c-eventProgress__intervals">
      @for (item of pointsPerBagMultiplier; track item; let i = $index) {
        <div class="interval"></div>
      }
    </div>
  </div>

  <span class="c-eventProgressBar__right-icon">
    <ng-content select="[eventProgressBarIcon] [eventProgressBarIconPos=right]"></ng-content>
  </span>
</div>
